
import { GrantType } from '@/common/permission';
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';
import { Message } from 'element-ui';

export default {
  components: { Uploader: Uploader },
  props: {
    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      uploaderAttr: {
        withCredentials: true,
        data: { bucket: 'mws-files' },
        accept: reduceFileAccept(['jpg', 'jpeg', 'png'])
      }
    };
  },

  methods: {
    checkDisabled: function checkDisabled(type) {
      return this.formValue.grant_type !== GrantType.Normal;
    },
    beforeUpload: function beforeUpload(file) {
      var isLt = file.size / 1024 > 500;
      if (isLt) {
        Message.warning('邮件截图大小不得超过500KB');
      }
      return !isLt;
    },
    successUpload: function successUpload(response) {
      if (response.code === 0) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.bill_method_image = response.data.url;
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.approval_url = response.data.file_path.substring(response.data.file_path.indexOf('mws-files://') + 'mws-files://'.length);
      } else {
        Message.error(response.msg);
      }
    }
  }
};